<template>
    <div v-if="plan.planos_vinculados && plan.planos_vinculados.length > 0">
        <div v-for="(p) in plan.planos_vinculados" :key="p.id">
            <div class="plan-container">
                <h2 class="title">
                    {{ p.plano ? p.plano.name : p.name }}
                    <span>{{ getQuantidade(p) }}x</span>
                </h2>
                <span class="planPrice">
                    {{ toMoney((p.price || (p.plano ? p.plano.price : 0)) / 100) }}
                    <span class="mes">{{ getRecorrenciaTexto(p) }}</span>
                </span>
            </div>
        </div>
    </div>
    <div class="plan-container" v-else>
        <h2 class="title">
            {{ plan.name }}
            <span>{{ getQuantidade(plan) }}x</span>
        </h2>
        <span class="planPrice">
            {{ toMoney((plan.price || 0) / 100) }}
            <span class="mes">{{ getRecorrenciaTexto(plan) }}</span>
        </span>
    </div>
</template>

<script>
import { toMoney } from '../../../services/formater';

export default {
    name: "ShoppinCarDetailsCard",
    props: {
        plan: Object
    },
    methods: {
        getQuantidade(item) {
            if (!item) return 1;
            if (item.qtd !== undefined && item.qtd !== null) return item.qtd;
            if (item.qtd_membros !== undefined && item.qtd_membros !== null) return item.qtd_membros;
            if (item.quantidade !== undefined && item.quantidade !== null) return item.quantidade;

            if (item.plano) {
                if (item.plano.qtd !== undefined && item.plano.qtd !== null) return item.plano.qtd;
                if (item.plano.qtd_membros !== undefined && item.plano.qtd_membros !== null) return item.plano.qtd_membros;
            }

            return 1;
        },
        getRecorrenciaTexto(item) {
            if (!item) return "/mês";

            const interval = item.unit_interval || 
                             item.interval || 
                             (item.plano && (item.plano.unit_interval || item.plano.interval)) || 
                             this.plan?.unit_interval || 
                             this.plan?.interval;

            const tipos = {
                Monthly: "/mês",
                Bimonthly: "/bimestre",
                Quarterly: "/trimestre",
                SemiAnnual: "/semestre",
                Annual: "/ano"
            };

            return tipos[interval] || "/mês";
        }
    },
    setup() {
        return { toMoney }
    },
}
</script>

<style scoped>
    .plan-container{
        text-align: left;
        margin: 1.5rem 0;
    }

    .title{
        color: #000;
        font-size: 1.0625rem;
        font-weight: 600;
        margin-bottom: 0;
    }

    .title span{
        color: rgb(37, 37, 37);
        font-size: .9rem;
        font-weight: 600;
        margin-bottom: 0;
        margin-left: .5rem;
    }

    .local{
        color: #4d4d4d;
        font-size: .75rem;
        font-weight: 400;
        letter-spacing: -.24px;
        margin-top: .1875rem;
        margin-bottom: .4rem;
    }

    .planPrice{
        color: #c90c53;
        font-size: 1rem;
        font-weight: 600;
        display: flex;
        align-items: center;
    }

    .mes{
        color: #747474;
        font-size: .75rem;
        font-weight: 500;
        display: block;
        margin-left: .1875rem;
    }
</style>